module.exports = __webpack_public_path__ + "assets/31dc63f7cc327c790f54f73f75fa18de.mp3";